<template>
  <div>
    <b-table
      class="mb-0"
      striped
      small
      hover
      responsive
      :items="innerValue.etrip_users"
      :fields="fields"
      :show-empty="innerValue.etrip_users && !innerValue.etrip_users.length"
      :empty-text="$gettext('no results found')"
    >
      <template v-slot:head(buttons)>
        <b-btn
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="edit()">
          <fa-icon icon="plus"/>
          <translate>add</translate>
        </b-btn>
      </template>
      <template v-slot:cell(buttons)="{ index }">
        <edit-delete-buttons
          @edit="edit(index)"
          @remove="remove(index)"
        />
      </template>
    </b-table>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      button-size="sm"
      size="lg"
      ref="modal"
      :lazy="true"
      :title="objIndex !== undefined ? $gettext('edit') : $gettext('add')"
      @ok.prevent="save"
      >
      <template v-slot:modal-footer>
        <modal-buttons
          :type="objIndex !== undefined ? 'update' : 'add'"
          @save="save"
          @cancel="cancel"
        />
      </template>
      <ValidationObserver ref="modalForm" slim>
        <Form
          v-model="obj"
          :company="innerValue"
          :isNew="isNew"
          @save="save"/>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
import vModelMixin from '@/shared/mixins/v-model'
import uniqueId from 'lodash/uniqueId'
import cloneDeep from 'lodash/cloneDeep'
import Form from './ETripUserEdit.vue'

export default {
  mixins: [vModelMixin],
  props: ['isNew'],
  components: {
    Form,
  },
  data() {
    return {
      sortBy: null,
      sortDirection: null,
      fields: [
        { key: 'supplier.label', label: this.$gettext('supplier') },
        { key: 'partner.name', label: this.$gettext('partner') },
        { key: 'agent_code', label: this.$gettext('agent code') },
        { key: 'buttons', label: '' },
      ],
      obj: {},
      objIndex: null,
    }
  },
  methods: {
    edit(index) {
      this.objIndex = index
      if (index !== undefined) this.obj = cloneDeep(this.innerValue.etrip_users[index])
      else this.obj = { id: -uniqueId() }
      this.$refs.modal.show()
    },
    async remove(index) {
      const accepted = await this.$confirmModal()

      if (accepted) {
        this.innerValue.etrip_users.splice(index, 1)
        this.$toastDeleteSuccess()
      }
    },
    async save() {
      const isValid = await this.$refs.modalForm.validate()
      if (isValid) {
        if (this.objIndex !== undefined) {
          this.innerValue.etrip_users.splice(this.objIndex, 1, this.obj)
        } else {
          this.innerValue.etrip_users.push(this.obj)
        }
        this.$toastSaveSuccess()
        this.cancel()
      } else {
        this.$toastInvalidForm()
      }
    },
    cancel() {
      this.$refs.modal.hide()
    },
  },
}
</script>
